/**
 * 域名工具函数
 * 用于根据当前域名动态生成正确的跳转链接
 */

/**
 * 检测当前域名是否为香港域名
 * @returns {boolean} 是否为香港域名
 */
export function isHkDomain() {
  return window.location.hostname === 'hk.talk915.com';
}

/**
 * 根据当前域名获取基础域名
 * @returns {string} 基础域名
 */
export function getBaseDomain() {
  const hostname = window.location.hostname;

  // 本地环境判断(localhost、127.0.0.1或内网IP)
  const isLocalEnv =
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.startsWith('10.') ||
    hostname.startsWith('192.168.') ||
    /^172\.(1[6-9]|2[0-9]|3[0-1])\./.test(hostname);

  if (isLocalEnv) {
    return `http://${hostname}:${window.location.port || '8080'}`;
  }

  // 其他环境（测试、生产等）统一使用 https + 当前 hostname
  return `https://${hostname}`;
}

/**
 * 生成教师相关链接
 * @param {string} path - 路径部分
 * @returns {string} 完整的跳转链接
 */
export function getTeacherLink(path) {
  const baseDomain = getBaseDomain();
  return `${baseDomain}${path}`;
}

/**
 * 获取所有教师相关的动态链接
 * @returns {object} 包含所有教师链接的对象
 */
export function getTeacherLinks() {
  return {
    TEACHER_LINK: getTeacherLink('/teacher/home'),
    TEACHER_CONTRACT: getTeacherLink('/teacher/beginner-guide'),
    TEACHER_MODIFY_LINK: getTeacherLink('/teacher/more-info'),
    TEACHER_AGT_LINK: getTeacherLink('/teacher/agt-home'),
    TEACHER_LOGIN_LINK: getTeacherLink('/teacher/login')
  };
}

/**
 * 获取其他相关链接
 * 只有STUDENT_LINK需要根据域名动态调整，其他链接使用环境变量
 * @returns {object} 包含其他链接的对象
 */
export function getOtherLinks() {
  const baseDomain = getBaseDomain();
  return {
    STUDENT_LINK: `${baseDomain}/student/home/learning-hall`,
    AGENT_LINK: process.env.AGENT_LINK,
    ADMIN_LINK: process.env.ADMIN_LINK
  };
}



// WEBPACK FOOTER //
// ./src/utils/domainUtils.js